<template>
    <v-card class="ma-0 pa-0">
        <p-add-package-popup
                ref="p-add-package-popup"
                v-on:show-p-file-preview-popup="onPreviewPackage">
        </p-add-package-popup>
        <p-file-preview-popup ref="p-file-preview-popup"></p-file-preview-popup>
        <p-packages-deploy-popup ref="p-packages-deploy-popup"></p-packages-deploy-popup>
        <v-card-actions class="ma-0 pa-0">
            <v-card width="100%" class="ma-0 pa-0" elevation="0" outlined>
                <v-card-actions class="ma-0 pa-2">
                    <v-spacer></v-spacer>
                    <v-btn :disabled="!ifCanCreateNewPackage()"
                            color="blue"
                            elevation="0"
                            class="white--text pl-5 pr-3"
                            @click="addNewPackage">
                        NEW PACKAGE
                        <v-icon class="ml-2">mdi-plus</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-card-actions>
        <v-card-actions class="ma-0 pa-0 mt-2">
            <v-card elevation="0" width="100%" class="ma-0 pa-0" outlined>
                <v-data-table
                        style="width: 100%;"
                        fixed-header
                        :items="packages"
                        :headers="headers"
                        hide-default-footer
                        disable-pagination>

                    <template v-slot:item.updated="{ item }">
                        <v-card-text>{{ item.updated | formatDate }}</v-card-text>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn :disabled="!ifCanEditPackage()"
                                        icon
                                       color="green"
                                       v-bind="attrs"
                                       v-on="on"
                                       class="mr-1"
                                       @click="onPressEdit(item.id)">
                                    <v-icon size="22">mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>Edit Package</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn :disabled="!ifCanDeletePackage()"
                                       :loading="deleting.includes(item.id)"
                                       icon
                                       color="red"
                                       v-bind="attrs"
                                       v-on="on"
                                       class="mr-1"
                                       @click="onPressDelete(item.id)">
                                    <v-icon size="22">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Delete Package</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn :disabled="!ifCanActivatePackage()"
                                       icon
                                       color="blue"
                                       v-bind="attrs"
                                       v-on="on"
                                       class="mr-1"
                                       @click="onPressActivate(item.id)">
                                    <v-icon size="22">mdi-arrow-right-thin-circle-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>Activate package</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
                </v-card>
        </v-card-actions>
    </v-card>
</template>

<script>

import {PackageStoreUtils} from "@/modules/mpackages/database/PackageStoreUtils";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import PFilePreviewPopup from "@/modules/mpackages/views/popups/p-file-preview-popup/p-file-preview-popup";
import PAddPackagePopup from "@/modules/mpackages/views/popups/p-add-package-popup/p-add-package-popup";
import PPackagesDeployPopup from "@/modules/mpackages/views/popups/p-packages-deploy-popup/p-packages-deploy-popup";

export default {
    name: "v-packages-drafts-list",
    components: {PPackagesDeployPopup, PAddPackagePopup, PFilePreviewPopup},
    data: () => ({
        headers: [
            {text: 'Id', sortable: true, value: 'id', class: "white blue--text", color: "red"},
            {text: 'Name', sortable: true, value: 'name', class: "white blue--text", color: "red"},
            {text: 'Description', sortable: true, value: 'description', class: "white blue--text", color: "red"},
            {text: 'Owner', sortable: true, value: 'createdBy', class: "white blue--text", color: "red"},
            {text: 'Updated', sortable: true, value: 'updated', class: "white blue--text", color: "red"},
            {text: 'Actions', sortable: false, value: 'actions', class: "white blue--text", width:'160px', align:'end'}
        ],
        deleting: [],
    }),
    mounted() {
        this.reloadData();
    },
    methods:{
        reloadData(){
            PackageStoreUtils.fethPackages()
            .then(() => {
                this.$notify({title: "Succes", text: "", type: "succes"});
            }).catch((error) => {
                this.$notify({title: 'Error:', text: error, type: "error"});
            })
        },
        getMyUserUid(){
            return PermissionsStoreUtils.getMyUserUid();
        },
        ifCanCreateNewPackage(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.PACKAGE_TAB.subpermissions.PACKAGE_TAB_DR_CREATE_NEW_PACKAGE.id)
        },
        ifCanEditPackage(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.PACKAGE_TAB.subpermissions.PACKAGE_TAB_DR_EDIT_PACKAGE.id)
        },
        ifCanDeletePackage(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.PACKAGE_TAB.subpermissions.PACKAGE_TAB_DR_DELETE_PACKAGE.id)
        },
        ifCanActivatePackage(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.PACKAGE_TAB.subpermissions.PACKAGE_TAB_DR_ACTIVATE_PACKAGE.id)
        },


        onPressActivate(packageId){
            this.$refs['p-packages-deploy-popup'].show(packageId)
        },
        onPreviewPackage(packageId, fileName){
            this.$refs['p-file-preview-popup'].show(packageId, fileName)
        },
        addNewPackage(){
            this.$refs['p-add-package-popup'].show('', false)
        },
        onPressEdit(packageId){
            this.$refs['p-add-package-popup'].show(packageId, true)
        },
        onPressAddToDeploy(packageId){
            this.$store.commit('deploy-store/addPendingForDeploy', packageId)
            this.$notify({title: 'Added: ' + packageId, text: "", type: "succes"});
        },
        onPressDelete(packageId){
            this.$confirm("Are you sure?" + packageId)
            .then(() => {
                this.deleting.push(packageId)
                PackageStoreUtils.deletePackage(packageId)
                    .then(() => {
                        this.deleting = []
                    })
                    .catch(() => {
                        this.deleting = []
                    })
            }).catch(() => {

            })
        }
    },
    computed:{
        packages(){
            return PackageStoreUtils.getPackages()
        }
    }
}
</script>

<style scoped>
</style>